import React from 'react';
import HomeIcon from '@material-ui/icons/Home';
//import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
// import Switch from '@mui/material/Switch';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import FormGroup from '@mui/material/FormGroup';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
//import NotificationsIcon from '@mui/icons-material/Notifications';
import Link from '@mui/material/Link';
import { useTranslation } from 'react-i18next';
//import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

// const useStyles = makeStyles(() => ({
//   link: {
//     color: 'white',
//     textDecoration: 'none',
//   },
//   menulink: {
//     textDecoration: 'none',
//     color: 'black',
//   },
// }));

export default function NavBarAdmin({ user, token }) {
  // const classes = useStyles();
  const { t } = useTranslation();
  const [anchorEl2, setAnchorEl2] = React.useState(null);

  // account
  const handleMenu2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };
  return (
    <div>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>
            <Link
              href="/"
              underline="none"
              style={{ color: 'white', textDecoration: 'none' }}
            >
              <HomeIcon
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ ml: 2 }}
              >
                <MenuIcon />
              </HomeIcon>
            </Link>

            <Typography
              variant="h5"
              component="div"
              sx={{ flexGrow: 1, ml: 2 }}
              style={{ fontStyle: 'bold' }}
            >
              <Link
                href="/"
                underline="none"
                style={{ color: 'white', textDecoration: 'none' }}
              >
                {t('nav-bar-user-home')}
              </Link>
            </Typography>
            {
              <div>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu2}
                  color="inherit"
                >
                  <AccountCircle sx={{ mr: 5, ml: 0, pl: 0 }} />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl2}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={Boolean(anchorEl2)}
                  onClose={handleClose2}
                >
                  <MenuItem onClick={handleClose2}>
                    <Link
                      href="#"
                      underline="none"
                      style={{ color: 'black', textDecoration: 'none' }}
                    >
                      Profile
                    </Link>
                  </MenuItem>
                  <MenuItem onClick={handleClose2}>
                    <Link
                      href="#"
                      underline="none"
                      style={{ color: 'black', textDecoration: 'none' }}
                    >
                      Logout
                    </Link>
                  </MenuItem>
                </Menu>
              </div>
            }
          </Toolbar>
        </AppBar>
      </Box>
    </div>
  );
}
